module.exports = __webpack_public_path__ + "site/img/heartred.9747d304.svg";